import userService from 'services/userData';
import GeneralConfig from 'services/metaData/generalConfig';

const generalConfigs = GeneralConfig();

export default async function (path) {
    const userData = await userService.getUserData();
    if (userData.companyStreamRailToken) {
        return `${generalConfigs.streamRailUrl + path}authorization=Bearer%20${userData.companyStreamRailToken}`;
    }
    return `${generalConfigs.streamRailUrl}/#/inactive`;
}
